import i18next from "i18next";

export const LANGS = [
  { code: "tr", label: "Türkçe", short: "TR" },
  { code: "en", label: "English", short: "EN" },
  { code: "de", label: "Deutsch", short: "DE" },
  { code: "it", label: "Italiano", short: "IT" },
  { code: "bg", label: "Български", short: "BG" },
  { code: "ro", label: "Română", short: "RO" },
  { code: "uk", label: "Українська", short: "UK" },
];
const CODES = LANGS.map((l) => l.code);
const KEY = "aportta_lang";

// Kayıtlı tercih > tarayıcı dili > Türkçe
export function detectLanguage() {
  const saved = localStorage.getItem(KEY);
  if (CODES.includes(saved)) return saved;
  const nav = (navigator.languages || [navigator.language || ""]).map((l) => String(l).slice(0, 2).toLowerCase());
  return nav.find((l) => CODES.includes(l)) || "tr";
}

const load = (lng) => import(`../locales/${lng}.json`).then((m) => m.default).catch(() => ({}));

export async function initI18n() {
  const lng = detectLanguage();
  const [tr, cur] = await Promise.all([load("tr"), lng === "tr" ? null : load(lng)]);
  const resources = { tr: { translation: tr } };
  if (cur) resources[lng] = { translation: cur };
  await i18next.init({ lng, fallbackLng: "tr", resources, interpolation: { escapeValue: false }, returnNull: false, returnEmptyString: false });
  document.documentElement.lang = lng;
}

export const tx = (key, opts) => i18next.t(key, opts);
export const unit = (u) => i18next.t(`common.unit_${u}`);
export const currentLanguage = () => i18next.language || "tr";
const DATE_LOCALES = { tr: "tr-TR", en: "en-GB", de: "de-DE", it: "it-IT", bg: "bg-BG", ro: "ro-RO", uk: "uk-UA" };
export const dateLocale = () => DATE_LOCALES[currentLanguage()] || "tr-TR";

// Dil değişince sayfa yeniden yüklenir; tüm metinler yeni dille baştan oluşur
export async function setLanguage(code, { save = true } = {}) {
  if (!CODES.includes(code)) return;
  localStorage.setItem(KEY, code);
  if (!save) markLanguagePicked();
  if (save) {
    const { default: api } = await import("@/lib/api");
    await api.patch("/me/language", { language: code }).catch(() => {});
  }
  if (code !== currentLanguage()) window.location.reload();
}

// Giriş sonrası hesaptaki tercih bu cihazdakinden farklıysa uygula.
// Giriş ekranında dil elle seçildiyse o seçim hesaba yazılır.
const HOME = { admin: "/admin", driver: "/driver", customer: "/app" };
export function markLanguagePicked() { sessionStorage.setItem("aportta_lang_picked", "1"); }
export function syncUserLanguage(user) {
  if (!user) return;
  const save = () => import("@/lib/api").then(({ default: api }) => api.patch("/me/language", { language: currentLanguage() }).catch(() => {}));
  if (sessionStorage.getItem("aportta_lang_picked")) { sessionStorage.removeItem("aportta_lang_picked"); if (user.language !== currentLanguage()) save(); return; }
  const l = user.language;
  if (!l) { save(); return; }
  if (!CODES.includes(l) || l === currentLanguage()) return;
  localStorage.setItem(KEY, l);
  if (/^\/(login|register)/.test(window.location.pathname)) window.location.href = HOME[user.role] || "/";
  else window.location.reload();
}
